import React, {Component} from 'react';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,linkFormatter,
    historyDataFormatter,
    dateFormatter,
    customFormatter,
    getFieldByPathFormatter
} from 'util/Utils';

import HistoryDataModal   from 'shared/HistoryDataModal'
import {browserHistory, Link} from 'react-router';
import MDHistory from 'react-icons/lib/md/history';
import config from  '../../../config';
import {
    UPDATE_ADMIN_PRODUCT, DELETE_ADMIN_PRODUCT, ADD_SELECTED_PRODUCTS,
    REMOVE_SELECTED_PRODUCTS
} from "actions/actionTypes";
import moment   from 'moment'
class AdminPalletsListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},

        };

    }
    arriveDateFormatter(cell, row, extra) {
        if (_.get(row, 'PalletCustomData.ArrivalDateFrom')){

            return <div><div>Expected</div>
            <span>{moment(_.get(row, 'PalletCustomData.ArrivalDateFrom')).format('MM/DD')}</span>
                &nbsp;-&nbsp;
                <span>{moment(_.get(row, 'PalletCustomData.ArrivalDateTo')).format('MM/DD')}</span>
            </div>
        }else{
            return null
        }


    }
    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []

        menuItemsMap.push({onClick: 'editRecord', label: 'Edit'})
        menuItemsMap.push({onClick:function() {
            this.props.importProductsAction(row);
        }, label: 'Import products'
        })
         if (!row.Deleted) {
             if ( row.PalletProductsNumber ==0 && _.size(_.intersection(this.props.userReducer.user.Roles,  [ 'Administrator'])) ) {
                menuItemsMap.push({onClick: 'showRemoveDialog', label: 'Delete'})
            }
        }
        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    editRecord(row) {
        this.props.editRecord(row);
    }

    showRemoveDialog(row) {
        this.props.showRemoveDialog(row)
    }




    hideHistoryDataModal() {
        this.setState({currentRecord: {}, historyDataModalVisible: false});
    }




    render() {
        //      console.log('state', this.state  );
         return (
            <div className="top20 databases-table">
                <BootstrapTable data={this.props.adminPallets.data} ref='table'
                                remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }

                >
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='PalletNumber'
                                       editable={ false } dataSort={true}>Pallet &#8470;</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='PalletID'
                                       editable={ false } dataSort={true}>Pallet ID</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='Notes'
                                       editable={ false } dataSort={true}>Notes</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataField="PalletCustomData.ArrivalDateFrom" dataAlign="center"
                                       dataFormat={ this.arriveDateFormatter.bind(this) }
                                       editable={ false }

                                       dataSort={true}>Arrive Date</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='Tracking'
                                       editable={ false } dataSort={true}>Tracking</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataAlign="center"
                                       dataFormat={(cell, row, extra)=>{
                                           if (_.get(row, extra.labelPath, 0) >0) {
                                               return linkFormatter(cell, row, extra)
                                           } else {
                                               return <div>{_.get(row, extra.labelPath, extra.label ? extra.label : 'Link')} </div>
                                           }

                                       } }
                                       formatExtraData={ {
                                           labelPath: ['PalletProductsNumber'],
                                           path: ['_id'],
                                           formatPathValue:(value)=>{
                                               return   encodeURIComponent(value)
                                           },
                                           placeholder: '[pallet_id]',
                                           template: config.getEnvironment().serverBaseURL +'/admin/products?PalletID=[pallet_id]',
                                       }  }
                                       dataField='PalletProductsNumber'
                                       editable={ false } dataSort={true}>&#8470; items</TableHeaderColumn>
                    <TableHeaderColumn width="45px" dataAlign="center" dataField='Type'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['Status'], format: (value) => {
                            return  _.startCase(value)
                        }
                    }}
                                       editable={ false } dataSort={true}>Status</TableHeaderColumn>

                    <TableHeaderColumn width="70px" formatExtraData={ {path: ['SellerID', 'DisplayName']}}
                                       editable={ false } dataFormat={ getFieldByPathFormatter }
                                       dataField='SellerID.DisplayName' dataAlign="center"
                                       dataSort={true}>Seller</TableHeaderColumn>
                    {/*<TableHeaderColumn width="30px" dataAlign="center" dataField="ChangeLog"*/}
                                                                  {/*editable={ false } dataSort={true}*/}
                                                                  {/*dataFormat={ (cell, row)=> historyDataFormatter(row, 'ChangeLog' )}>Change Log</TableHeaderColumn>*/}
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='MarketName'
                                       editable={ false } dataSort={true}>Market</TableHeaderColumn>
                    <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="20px" dataAlign="center" columnClassName={'actions-column'}
                                       editable={ false }
                                       dataFormat={ this.customActionsFormatter.bind(this) }>Actions</TableHeaderColumn>
                </BootstrapTable>
                <HistoryDataModal data={this.state.currentRecord} hideModal={this.hideHistoryDataModal.bind(this)}
                                show={this.state.historyDataModalVisible}></HistoryDataModal>
            </div>
        );
    }
}


export default AdminPalletsListTable;
